import { createContext, useContext } from 'react';
const useApplyFilter = () => useContext(ApplyFilterContext);
export default useApplyFilter;
export const ApplyFilterContext = createContext({});
